import { CIAction, CIActionEnum, CIState } from "./types";

const initialState: CIState = {
  indexId: 0,
  chartData: null,
};

export default function authReducer(
  state = initialState,
  action: CIAction
): CIState {
  switch (action.type) {
    case CIActionEnum.SET_INDEX_ID:
      return { ...state, indexId: action.payload };
    case CIActionEnum.SET_CHART_DATA_TYPE:
      return { ...state, chartData: action.payload };
    default:
      return state;
  }
}
